import { ReactNode } from 'react';
import { BADGE_VARIANTS, Badge } from 'ui/badge';
import { CollapsibleContent } from 'ui/collapsibleContent';
import {
  CardActions,
  CardRow,
  CardWrapper,
  Details,
  Logo,
  MetaItem,
  Metadata,
  StyledCollapsibleContentArrow,
  Title,
} from './SourceCard.styled';

export const SOURCE_CARD_TEXT = {
  actionsId: 'source-card-actions',
  cardId: 'source-card',
  contentId: 'source-card-content',
  metadataId: 'source-card-metadata',
  titleId: 'source-card-title',
};

const { actionsId, cardId, contentId, metadataId, titleId } = SOURCE_CARD_TEXT;

export type SourceCardProps = {
  Actions: ReactNode;
  children: ReactNode;
  Icon: any;
  isOpen: boolean;
  name: string;
  setIsOpen: (isOpen: boolean) => void;
  syncsCount: {
    total: number;
    errors: number;
  };
  type: string;
};

export const SourceCard = ({
  Actions,
  children,
  Icon,
  isOpen,
  name,
  setIsOpen,
  syncsCount,
  type,
}: SourceCardProps) => (
  <CardWrapper data-test={cardId}>
    <CardRow>
      <Details onClick={() => setIsOpen(!isOpen)}>
        <StyledCollapsibleContentArrow isCollapsed={!isOpen} />
        <Logo>
          <Icon width={48} height={48} />
        </Logo>
        <Title data-test={titleId}>{name}</Title>
        <Metadata data-test={metadataId}>
          <MetaItem>{type}</MetaItem>
          <MetaItem>
            <span>{syncsCount.total === 1 ? '1 sync' : `${syncsCount.total} syncs`}</span>
            {syncsCount.errors > 0 && (
              <Badge variant={BADGE_VARIANTS.COUNTER_ERROR}>{syncsCount.errors}</Badge>
            )}
          </MetaItem>
        </Metadata>
      </Details>
      <CardActions data-test={actionsId}>{Actions}</CardActions>
    </CardRow>
    {children && (
      <CollapsibleContent data-test={contentId} isCollapsed={!isOpen}>
        {children}
      </CollapsibleContent>
    )}
  </CardWrapper>
);
